import { Link, useSearchParams } from "react-router-dom";
import { Stack } from "react-bootstrap";

import { useMutation } from "../../hooks";
import UserForm from "./UserForm";
import { UserFormInterface, UserMutationResponse } from "./types";

const blankUser = {
  email: "",
  first_name: "",
  last_name: "",
  city: "",
  state: "",
};
export default function Signup() {
  const [searchParams] = useSearchParams();
  const signupToken = searchParams.get("signup");

  const mutation = useMutation("users/signup") as UserMutationResponse;

  function handleSubmit(values: UserFormInterface) {
    mutation.mutate({ ...values, signupToken });
  }

  const buttons = (dirty: boolean) => (
    <Stack className="d-flex align-items-center" gap={3}>
      <button className="button" type="submit" disabled={!dirty}>
        Request Login Link
      </button>
      <div>
        <Link className="button text" to="/login">Been here before? Login Here</Link>
      </div>
    </Stack>
  );

  return (
    <Stack className="col-md-8 col-lg-6 mx-auto">
      <h2>Signup</h2>
      <UserForm
        buttons={buttons}
        mutationResponse={mutation}
        onSubmit={handleSubmit}
        user={blankUser}
        register
      />
    </Stack>
  );
}
